// Basic Routing setup
WiseMetering.Router = Backbone.Marionette.AppRouter.extend({
    appRoutes: {
        '': 'drawDefault',
        'actuators': 'drawActuators',
        'admin': 'drawAdmin',
        'alarms': 'drawAlarms',
        'design_system': 'drawDesignSystem',
        'alarms/:id/edit': 'drawEditAlarm',
        'alarms/create?indicator_id=:indicator_id': 'drawCreateAlarm',
        'alarms/bulk_create': 'drawBulkCreateAlarms',
        'alarms/bulk_delete': 'drawBulkDeleteAlarms',
        'alarms/bulk_edit': 'drawBulkEditAlarms',
        'alarms/:id/show': 'drawShowAlarm',
        'all_tenants': 'drawTenants',
        'all_tenants/:id': 'drawTenant',
        'api_keys': 'drawApiKeys',
        'api_keys/new': 'drawNewApiKey',
        'api_keys/:id/edit': 'drawEditApiKey',
        'sites/:id/:view': 'drawSite',
        'site_tags': 'drawSiteTags',
        'site_tags/new': 'drawNewSiteTag',
        'site_tags/:id/edit': 'drawEditSiteTag',
        'chat': 'drawChat',
        'circuits': 'drawCircuits',
        'circuits/:id?*querystring': 'drawCircuit',
        'circuits/:id': 'drawCircuit',
        'circuit_types': 'drawCircuitTags',
        'circuit_types/new': 'drawNewCircuitType',
        'companies': 'drawCompanies',
        'companies/new': 'drawNewCompany',
        'companies/:id/edit': 'drawEditCompany',
        'contracts/:id/:view?*querystring': 'drawContract',
        'contracts/:id/:view': 'drawContract',
        'custom_dashboard': 'drawCustomDashboard',
        'dashboard': 'drawDashboard',
        'devices': 'drawDevices',
        'events': 'drawEvents',
        'events?*querystring': 'drawEvents',
        'etls': 'drawEtls',
        'etls/new': 'drawNewEtl',
        'etls/:id/edit': 'drawEditEtl',
        'folders/:id': 'drawFolder',
        'groups': 'drawGroups',
        'groups/new': 'drawNewGroup',
        'groups/:id/edit': 'drawEditGroup',
        'holidays': 'drawHolidays',
        'home': 'drawDashboard',
        'indicators': 'drawIndicators',
        'indicators/new': 'drawNewIndicator',
        'indicators/new?*querystring': 'drawNewIndicator',
        'indicators/:id/edit': 'drawEditIndicator',
        'indicators/:id/edit?*querystring': 'drawEditIndicator',
        'indicators/:id/:view?*querystring': 'drawIndicator',
        'indicators/:id/:view': 'drawIndicator',
        'integrations/:id/:view': 'drawIntegration',
        'integration_licenses/:id/:view': 'drawIntegrationLicense',
        'integration_licenses/:id': 'drawIntegrationLicense',
        'integration_licenses/:id/integrations/new': 'drawNewIntegration',
        'integration_licenses/:license_id/integrations/:id/edit': 'drawEditIntegration',
        'leads': 'drawLeads',
        'map': 'drawMap',
        'login': 'drawLogin',
        'markers': 'drawMarkers',
        'markers/:id/edit': 'drawEditMarker',
        'notifications': 'drawNotifications',
        'organizations/create': 'createOrganization',
        'organizations/:id': 'drawOrganization',
        'organizations/:id/edit': 'editOrganization',
        'readings': 'drawReadings',
        'reports': 'drawReports',
        'reports/new': 'drawNewReport',
        'reports/new?*querystring': 'drawNewReport',
        'scheduled_reports': 'drawScheduledReports',
        'scheduled_reports/new': 'drawNewScheduledReport',
        'scheduled_reports/new?*querystring': 'drawNewScheduledReport',
        'scheduled_reports/:id/edit': 'drawEditScheduledReport',
        'scheduled_reports/:id/edit?*querystring': 'drawEditScheduledReport',
        'seus/:id': 'drawSeu',
        'signup': 'drawSignup',
        'tariffs': 'drawTariffs',
        'reset_password/:id': 'drawResetPassword',
        'root_objects/:id/:view': 'drawRootObject',
        'root_objects/:id': 'drawRootObject',
        'tenants/:id': 'drawTenant',
        'tree': 'drawTree',
        'users': 'drawUsers',
        'users/new': 'drawNewUser',
        'users/:id/edit': 'drawEditUser',
        'user_profile': 'drawUserProfile',
        'utilities/:id/:view': 'drawUtility',
        'utilities/:id/:view?*querystring': 'drawUtility',
        'wise-store': 'drawWiseStore',
        'zone_attributes': 'drawZoneAttributes',
        'zone_attributes/new': 'drawNewZoneAttribute',
        'zone_attributes/:id/edit': 'drawEditZoneAttribute',
        'zones/:id/:view': 'drawZone',
        'zones/:id/:view?*querystring': 'drawZone',
        '*path': 'drawDefault'
    }
});

WiseMetering.addInitializer(() => {
    $(document).on('click', 'a[href^="/"]', function (event) {
        event.preventDefault();
        const href = $(event.currentTarget).attr('href');
        Backbone.history.navigate(href, { trigger: true });
    });

    new WiseMetering.Router({ controller: WiseMetering.controller });
    Backbone.history.start({ pushState: true, silent: true });
});
